MeCommunicationsController.$inject = []

export default function MeCommunicationsController() {
  
}